export const SEND_INVITATION = "SEND_INVITATION";
export const GET_INVITATION_CODE = "GET_INVITATION_CODE";
export const GET_INVITATIONS = "GET_INVITATIONS";
export const GET_REFERREDS = "GET_REFERREDS";
